import React from 'react'
import { useRouter } from 'next/router'
import { init } from '@jarvis.oddle/core/tools/lib'
import { appResource } from '@jarvis.oddle/core/env'

const safeGtag = (...args) => window.gtag && window.gtag(...args)

const PerformanceTracker = (): JSX.Element => {
  const router = useRouter()
  const { isBrowserStack } = router.query
  const prependLabel = isBrowserStack ? 'browserStack-' : ''

  React.useEffect(() => {
    if (!window.__performanceTrackingEnabled) return

    (window.__performanceMetrics || []).forEach(({ action, label, value }) => {
      safeGtag('event', action, {
        event_category: 'performance',
        event_label: `${prependLabel}${label}`,
        value,
        non_interaction: true
      })
    })

    init(appResource('/js/ttiPolyfill.js', 'ttiPolyfill')).then(() => {
      if (window.ttiPolyfill) {
        window.ttiPolyfill.getFirstConsistentlyInteractive().then((value) => {
          safeGtag('event', 'tti', {
            event_category: 'performance',
            event_label: `${prependLabel}tti_metric`,
            value,
            non_interaction: true
          })
        })
      }
    })
  }, [prependLabel])

  return null
}

export default PerformanceTracker
